import { Injectable } from '@angular/core';
import {Helper} from '../../utils/helper.module';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import {HttpClient} from "@angular/common/http";


@Injectable()
export class AccountService {

  constructor(private http: HttpClient, private router: Router, private authService: AuthService) { }

  updateProfile(user): Promise<any> {
    return this.http.put(Helper.api('users/'+user.id), user)
      .toPromise()
      .then((res) => {
        console.log("api res", res);
        let user = res['user'];
        this.authService.storeUser(user);
        return Promise.resolve(user);
      })
      .catch(this.handleError);
  }

  saveDocument(userDocument) {
    return this.http.post(Helper.api('saveDocumentData'), userDocument)
      .toPromise()
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch(this.handleError);
  }

  loadUserDocument(user_id) {
    return this.http.get(Helper.api('getUserDocument/'+user_id))
      .toPromise()
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch(this.handleError);
  }

  unlockWithPassWord(passwordEmail): Promise<any> {
    return this.http.post(Helper.api('unlockWithPassword'), passwordEmail)
      .toPromise()
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch(this.handleError);
  }
  createPayement(payment) {
    return this.http.post(Helper.api('createPayement'), payment)
      .toPromise()
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch(this.handleError);
  }

  loadUserPaymentInfo(user_id) {
    return this.http.get(Helper.api('userPayementInfo/'+user_id))
      .toPromise()
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch(this.handleError);
  }


  tickets(): Promise<any> {
    return this.http.get(Helper.api('front/connected-account-tickets'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  orders(): Promise<any> {
    return this.http.get(Helper.api('front/connected-account-orders'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  addOrEditDonorMessage(data:any): Promise<any> {
    return this.http.post(Helper.api('setdonormessage'),data)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  donnationDetail(id): Promise<any> {
    return this.http.get(Helper.api('donnations/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }
  changejackpotamountvisibility(id:any): Promise<any> {
    return this.http.get(Helper.api('changejackpotamountvisibility/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }
  editDonorName(data:any): Promise<any> {
    return this.http.post(Helper.api('editdonorname'),data)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  changejackpotanonym(id:any): Promise<any> {
    return this.http.get(Helper.api('changejackpotanonym/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  userdonnations(): Promise<any> {
    return this.http.get(Helper.api('userdonnations'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  userjackpots(): Promise<any> {
    return this.http.get(Helper.api('userjackpots'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  geTicketName(ticket_id): Promise<any> {
    return this.http.get(Helper.api('shared/ticket-name/' + ticket_id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }



  ticket(id): Promise<any> {
    return this.http.get(Helper.api('front/account-ticket-detail/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  qrcode(id): Promise<any> {
    return this.http.get(Helper.api('front/account-ticket-qr-code/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }


  downloadpdf(id): Promise<any> {
    return this.http.get(Helper.api('generate-pdf/'+id),{responseType:"blob"})
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  resendMail(id): Promise<any> {
    return this.http.get(Helper.api('send-back-ticket-by-mail/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  update(id,ticket): Promise<any> {
    return this.http.put(Helper.api('front/update-ticket/'+id), ticket)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  saveJackpot(jackpot: any): Promise<any> {
    return this.http.post(Helper.api('savejackpot'), jackpot)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  updateJackpot(id:any,jackpot: any): Promise<any> {
    return this.http.put(Helper.api('updatejackpot/'+id), jackpot)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  closeJackpot(id:any): Promise<any> {
    return this.http.get(Helper.api('closejackpot/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  unCloseJackpot(id:any): Promise<any> {
    return this.http.get(Helper.api('unClosejackpot/'+id))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  paymentInfo(): Promise<any> {
    return this.http.get(Helper.api('payments/'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  changeJackpotContributionShow(jackpot: any): Promise<any> {
    return this.http.post(Helper.api('changejackpotcontributionshow'), jackpot)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }


  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.msg || error.json());
  }

}
